module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agency form-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "agency-main"
  }, [_c('group', {
    attrs: {
      "title": "法定代表人或负责人",
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "representativeName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "姓名",
      "is-type": "china-name",
      "placeholder": "请输入姓名",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.representativeName),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeName", $$v)
      },
      expression: "data.representativeName"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeDocumentsType",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件类型",
      "placeholder": "请输入证件类型",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.representativeDocumentsType),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeDocumentsType", $$v)
      },
      expression: "data.representativeDocumentsType"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeIdCardNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件号码",
      "is-type": _vm.isIdCard,
      "placeholder": "请输入证件号码",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    on: {
      "on-change": _vm.idcardChange
    },
    model: {
      value: (_vm.data.representativeIdCardNo),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeIdCardNo", $$v)
      },
      expression: "data.representativeIdCardNo"
    }
  }), _vm._v(" "), _c('popup-radio', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "text-align": _vm.type === 0 ? 'right' : '',
      "title": "证件有效期",
      "options": ['永久有效', '存在有效期']
    },
    model: {
      value: (_vm.localValidity),
      callback: function($$v) {
        _vm.localValidity = $$v
      },
      expression: "localValidity"
    }
  }), _vm._v(" "), (_vm.localValidity === '存在有效期') ? _c('datetime', {
    ref: "representativeDocumentsValidity",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "有效日期",
      "min-year": 2000,
      "max-year": 2099,
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0
    },
    model: {
      value: (_vm.data.representativeDocumentsValidity),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeDocumentsValidity", $$v)
      },
      expression: "data.representativeDocumentsValidity"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('selector', {
    style: ({
      color: _vm.type === 0 ? 'rgba(0, 0, 0, 0.3)' : '',
      height: _vm.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "性别",
      "options": ['男', '女'],
      "placeholder": "请选择性别",
      "readonly": _vm.type === 0
    },
    model: {
      value: (_vm.data.representativeSex),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeSex", $$v)
      },
      expression: "data.representativeSex"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeAge",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "年龄",
      "type": "number",
      "placeholder": "请输入年龄",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.representativeAge),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeAge", $$v)
      },
      expression: "data.representativeAge"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "representativePosition",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "职务",
      "placeholder": "请输入职务",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.representativePosition),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativePosition", $$v)
      },
      expression: "data.representativePosition"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeLanline",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(座机)",
      "max": 20,
      "keyboard": "number",
      "is-type": _vm.isPhone,
      "placeholder": "格式：区号+座机号码",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.representativeLanline),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeLanline", $$v)
      },
      expression: "data.representativeLanline"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeMobile",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(手机)",
      "max": 11,
      "keyboard": "number",
      "is-type": "china-mobile",
      "placeholder": "请输入手机号码",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.representativeMobile),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeMobile", $$v)
      },
      expression: "data.representativeMobile"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeEmail",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电子邮箱",
      "is-type": "email",
      "placeholder": "请输入电子邮箱",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.representativeEmail),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeEmail", $$v)
      },
      expression: "data.representativeEmail"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "representativeZip",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "办公邮编",
      "max": 6,
      "type": "tel",
      "placeholder": "请输入办公邮编",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.representativeZip),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeZip", $$v)
      },
      expression: "data.representativeZip"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeAddress",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "办公地址",
      "placeholder": "请输入办公地址",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.representativeAddress),
      callback: function($$v) {
        _vm.$set(_vm.data, "representativeAddress", $$v)
      },
      expression: "data.representativeAddress"
    }
  })], 1), _vm._v(" "), (_vm.check && _vm.type === 1) ? _c('div', {
    staticStyle: {
      "text-align": "right",
      "padding": "5px 20px",
      "background-color": "#fff"
    }
  }, [_c('check-icon', {
    attrs: {
      "value": _vm.isThree
    },
    on: {
      "update:value": function($event) {
        _vm.isThree = $event
      }
    }
  }, [_vm._v("本人是授权经办人")])], 1) : _vm._e()], 1), _vm._v(" "), _c('submit-button', {
    on: {
      "click": _vm.$_agency_auth
    }
  }, [_vm._v("下一步")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b5b1899"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvestorInfo/Agency/Two.vue
// module id = 1056
// module chunks = 1